// ** Amplify
import { API } from "aws-amplify"
// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"

import { userRoles } from "@constants/system"
// ** constants
import { globalConst } from "@constants/global"

import { isEmpty, drop } from "lodash"

// ** fuzzy search support
import Fuse from "fuse.js"
import { devLog } from "@helpers/devLog"

const shouldSkipProtectedDashboardCalls = () => {
  // Server-authoritative admin dashboard: disable local fallback mode.
  return false
}

/** initla state for auth store  */
const initialState = {
  data: [],
  current: {},
  currentPage: 1,
  perPageValues: [20, 25, 30, 50],
  itemPerPage: 20,
  filters: {},
  message: "",
  keyword: null,
  action: globalConst.action.NONE
}

export const categories = {
  state: initialState,

  reducers: {
    /**
     * Set translate message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage: (s, payload) => {
      return {
        ...s,
        message: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setData: (s, payload) => {
      return {
        ...s,
        data: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    pushNewData: (s, payload) => {
    
      return {
        ...s,
        data: [...s.data, payload]
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setFilters: (s, payload) => {
      return {
        ...s,
        filters: { ...s.filters, ...payload }
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeyword: (s, payload) => {
      return {
        ...s,
        keyword: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setitemPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrent: (s, payload) => {
      return {
        ...s,
        current: payload
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrentPage: (s, payload) => {
      return {
        ...s,
        currentPage: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    error() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.stuffs],
        (stuffs, stuffsLoading) => {
          return stuffsLoading.error || ""
        }
      )
    },

    /**
     * success selector used in different
     * auth actions
     *
     * @returns {String}
     */
    success() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.categories],
        (categories, categoriesLoading) => categoriesLoading.success
      )
    },
    paginationData() {
      return createSelector([slice], (categories) => {
        devLog('=== CATEGORIES FILTER DEBUG ===')
        devLog('Filters object:', categories.filters)
        devLog('Total data count:', categories.data.length)
        devLog('Sample data:', categories.data.slice(0, 3).map(item => ({ name: item.name, status: item.status, statusType: typeof item.status })))

        let data = categories.data

        // Apply status filter if it exists
        if (categories.filters && categories.filters.status && categories.filters.status !== "all") {
          const status = categories.filters.status
          devLog('Applying status filter:', status)
          
          // Convert string status to boolean for comparison
          let filterStatus
          if (status === "active") filterStatus = true
          else if (status === "disabled") filterStatus = false
          else filterStatus = status
          
          data = data.filter((e) => {
            // Convert string status to boolean for comparison
            let itemStatus = e.status
            if (typeof itemStatus === 'string') {
              itemStatus = itemStatus === 'true' ? true : false
            }
            
            const result = itemStatus === filterStatus
            devLog(`Comparing: ${e.name} - status: ${e.status} (${typeof e.status}) -> ${itemStatus} (${typeof itemStatus}) with filter: ${filterStatus} (${typeof filterStatus}) = ${result}`)
            return result
          })
          
          devLog('After status filter, data count:', data.length)
        }

        // Apply role filter if it exists
        if (categories.filters && categories.filters.role) {
          const role = categories.filters.role
          data = role !== userRoles.ALL.toLocaleLowerCase()
            ? data.filter((e) => e.group === role)
            : data
        }

        // Apply keyword search if it exists
        if (categories.keyword) {
          const options = {
            keys: ["nickname", "name", "email"]
          }
          const fuse = new Fuse(data, options)
          data = fuse.search(categories.keyword)
          data = data.map((e) => e.item)
        }

        // Apply pagination
        const offset = (categories.currentPage - 1) * categories.itemPerPage
        const paginatedData = drop(data, offset).slice(0, categories.itemPerPage)
        
        devLog('Final paginated data count:', paginatedData.length)
        return paginatedData
      })
    }
  }),
  effects: (dispatch) => ({
    /**
     *
     */
    async fetchCategories() {
      appLogger.info("fetchCategories", `[REDUX][${STORES.CATEGORIES}]`)
      this.setAction(globalConst.action.FETCH_CATEGROEIS)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setData([])
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.get("prefsApiGateway", "/categories")
        this.setData(result)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setData([])
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     *
     * @param {*} payload
     */
    async saveNewCategory(payload) {
      appLogger.info("saveNewCategory", `[REDUX][${STORES.CATEGORIES}]`)
      this.setAction(globalConst.action.ADD_NEW_CATEGORY)
      try {
        const result = await API.post("prefsApiGateway", "/categories", {
          body: payload
        })
        const newCategory = {
          ...payload,
          pk: result.pk
        }
        this.pushNewData(newCategory)
        this.setMessage("msg_category_added_sucess")
      } catch (error) {
        throw new Error(error)
      }
    },

    /**
     *
     * @param {*} id
     */
    async disableStuff(id) {
    
      appLogger.info("disableStuff", `[REDUX][${STORES.STUFFS}]`)
      this.setAction(globalConst.action.DISABLE_STUFF)
      try {
        const result = await API.del("stuffsApiGateway", `/stuffs/${id}/status`)
        this.setMessage("msg_stuff_disabled")
      } catch (error) {
        const _error = error.message || error.response
        this.setError(_error)
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} id
     */
    async enableStuff(id) {
      appLogger.info("enableStuff", `[REDUX][${STORES.STUFFS}]`)
      this.setAction(globalConst.action.ENABLE_STUFF)
      try {
        const result = await API.put("stuffsApiGateway", `/stuffs/${id}/status`)
        this.setMessage("msg_stuff_enabled")
      } catch (error) {
        const _error = error.message || error.response
        this.setError(_error)
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} payload
     */
    async resetPasswordStuff({ pk, password }) {
      appLogger.info("resetPasswordStuff", `[REDUX][${STORES.STUFFS}]`)
      this.setAction(globalConst.action.RESET_STUFF)
      try {
        await API.put("stuffsApiGateway", `/stuffs/${pk}/account`, {
          body: { password }
        })
        this.setMessage("msg_stuffs_reset_sucess")
      } catch (error) {
        return new Error(error)
      }
    },
    /**
     * Get stuff by PK
     *
     * @param {*} id
     */
    async getStuff(id) {
      appLogger.info("getStuff", `[REDUX][${STORES.STUFFS}]`)
      this.setAction(globalConst.action.GET_STUFF)
      try {
        const result = await API.get("stuffsApiGateway", `/stuffs/${id}`)
        this.setCurrent(result)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     */
    onAcionReset() {
      this.setAction(globalConst.action.NONE)
    },
    /**
     *
     * @param {*} param0
     */
    resetCurrentRecord(payload = {}) {
      this.setCurrent(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemPerPageChange(payload) {
      this.setitemPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onFiltersChange(payload) {
      this.setFilters(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onKeywordChange(payload) {
      this.setKeyword(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onCurrentPageChange(payload) {
      this.setCurrentPage(payload)
    }
  })
}
